"use client";

import React from "react";
import { useUser as useClerkUser } from "@clerk/nextjs";

// Create a Session type similar to what components expect
type Session = {
  user?: {
    id: string;
    name?: string;
    email?: string;
    image?: string;
  } | null;
};

// Create context
const SessionContext = React.createContext<{ data: Session | null; status: string }>({
  data: null,
  status: "loading",
});

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const { user, isSignedIn, isLoaded } = useClerkUser();
  
  const session: Session | null = isLoaded 
    ? {
        user: isSignedIn ? {
          id: user?.id || "",
          name: user?.fullName || "",
          email: user?.primaryEmailAddress?.emailAddress,
          image: user?.imageUrl,
        } : null
      }
    : null;
  
  const status = !isLoaded ? "loading" : isSignedIn ? "authenticated" : "unauthenticated";
  
  return (
    <SessionContext.Provider value={{ data: session, status }}>
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  return React.useContext(SessionContext);
} 